import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const OfflineSave: FunctionComponent = () => {
	const {t} = useTranslation();

	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t('offlinelandingpage_title_saveyourdata_standalone-web', {
							ns: 'offline',
						})}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t('offlinelandingpage_text_saveyourdata_standalone-web', {
							ns: 'offline',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '250px', md: '100%'}}
					src="56ce94510845af5e68f18ac4e1ef1c3f.jpg"
					aspectRatio="866/578"
					alt={t(
						'metatag_text_downloadfavoriteplaylistsoffline_standalone-web',
						{ns: 'common'},
					)}
				/>
			}
		/>
	);
};
